// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"5ebda170","671":"bffdb4ab"}[chunkId] + ".chunk.js";
};